import { Nullable } from '@frontend/sports/common/core/utils/extended-types';

import { CriteriaType, IRewardToken, RewardTokenContext } from './reward-tokens.model';

export type TokensRecord = Record<string, IRewardToken>;

export interface IRewardTokensState {
    tokens: TokensRecord;
    eligibilityState: IRewardTokenEligibilityState;
    betstationTokens: IBetstationTokensState;
    onboardingState: IRewardTokensOnboardingState;
    tokenRecoveryState: ITokenRecoveryState[];
}
export interface IRewardTokenEligibilityState {
    singleBet: Record<string, IRewardTokenEligibility[]>;
    betBuilder: Record<string, IRewardTokenEligibility[]>;
    comboBet: IRewardTokenEligibility[];
    teaserBet: IRewardTokenEligibility[];
}

export interface IBetstationTokenState {
    selectedTokenId: string | null;
    eligibility: IRewardTokenEligibility | null;
}

export interface ITokenRecoveryState {
    tokenId: string;
    context: RewardTokenContext;
}

export interface ITokenStoreState extends ITokenRecoveryState {
    isRecoverable: boolean;
}

export interface IEdsTokenState {
    selectedTokenIds: string[];
    eligibilities: IRewardTokenEligibility[];
}

// Betstation has a separate state because it does not use tokens per slip like digital
// The tokens are eligibile for and applied to the entire betslip
// This cannot be achieved with the digital state and thus we need a separate state for BS
export interface IBetstationTokensState {
    // There will only be one BOG token at any given time
    bogTokenState: IBetstationTokenState;
    betStationFreeBet: IBetstationTokenState;
    edsState: IEdsTokenState;
}

export interface IRewardTokenEligibility {
    tokenId: string;
    isEligible: boolean;
    invalidHardCriteria: Nullable<CriteriaType>;
    eligiblePicksIds: string[];
    softCriteriasValidity: { [key: string]: boolean };
}

export interface IRewardTokensOnboardingState {
    visible: boolean;
    acquisitionHidden: boolean;
}

export const defaultRewardTokensState: IRewardTokensState = {
    tokens: {},
    eligibilityState: {
        singleBet: {},
        comboBet: [],
        teaserBet: [],
        betBuilder: {},
    },
    betstationTokens: {
        betStationFreeBet: {
            selectedTokenId: null,
            eligibility: null,
        },
        bogTokenState: {
            selectedTokenId: null,
            eligibility: null,
        },
        edsState: {
            selectedTokenIds: [],
            eligibilities: [],
        },
    },
    onboardingState: { visible: false, acquisitionHidden: false },
    tokenRecoveryState: [],
};
